import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {isLast ? (
              <span className="text-foreground-800 font-medium" aria-current="page">
                {item.name}
              </span>
            ) : item.path ? (
              <Link
                to={item.path}
                className="hover:text-primary-500 transition-colors"
              >
                {item.name}
              </Link>
            ) : (
              <span>{item.name}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}